export const chatbotStyles = `
  .chatbot-responsive-width {
    width: 100%;
    height: calc(100dvh - 40px) !important;
    height: calc(100svh - 40px) !important;
    max-height: 100dvh !important;
    max-height: 100svh !important;
  }
  
  /* Fix for iPhone devices to prevent content cutoff */
  @supports (-webkit-touch-callout: none) {
    .chatbot-responsive-width {
      height: calc(100dvh - 40px - env(safe-area-inset-bottom)) !important;
      max-height: calc(100svh - env(safe-area-inset-bottom)) !important;
      padding-bottom: env(safe-area-inset-bottom, 0);
    }
  }
  
  /* Default (large screens) */
   @media (min-width: 1025px) {
    .chatbot-responsive-width {
      width: 480px;
    }
  }
  
   /* Tablet view */
  @media (min-width: 768px) and (max-width: 1024px) {
    .chatbot-responsive-width {
      width: 400px !important;
      max-width: 400px !important;
      top: 20px !important;
      margin-right: 0 !important;
      padding-right: 0 !important;
    }
  }
  
  /* Mobile view - full screen */
  @media (max-width: 767px) {
    .chatbot-responsive-width {
      width: 100% !important;
    }
  }
  
  /* Fix specifically for iPad Mini 2021 dimensions */
  @media screen and (width: 744px) and (height: 1059px), 
         screen and (width: 1059px) and (height: 744px),
         screen and (min-width: 740px) and (max-width: 750px) and (min-height: 1050px) and (max-height: 1070px),
         screen and (min-width: 1050px) and (max-width: 1070px) and (min-height: 740px) and (max-height: 750px) {
    .chatbot-responsive-width {
      height: 100% !important;
      max-height: 100% !important;
      bottom: 0 !important;
      width: 400px !important;
      max-width: 400px !important;
    }
    
    /* Force the container to fill available space */
    .chatbot-responsive-width > div {
      height: 100% !important;
      padding-bottom: 0 !important;
    }
    
    /* Ensure the chat container properly fills the space */
    .chatbot-responsive-width .flex-1 {
      height: calc(100% - 120px) !important;
    }
    
    /* Fix input position */
    .chatbot-input-container {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      background-color: white;
    }
  }
  
  /* More specific selectors for iPad Mini */
  .ipad-mini-chatbot {
    position: fixed !important;
    top: 0 !important;
    bottom: 0 !important;
    right: 0 !important;
    height: 100% !important;
  }
  
  .ipad-mini-container {
    position: relative !important;
    height: 100% !important;
    min-height: 100% !important;
    display: flex !important;
    flex-direction: column !important;
  }
  
  .ipad-mini-content {
    flex: 1 !important;
    height: auto !important;
    overflow-y: auto !important;
  }
  
  .ipad-mini-input {
    position: sticky !important;
    bottom: 0 !important;
    background-color: white !important;
    border-top: 1px solid #e5e7eb !important;
    width: 100% !important;
    z-index: 10 !important;
  }
  
  html.ipad-mini body {
    height: 100% !important;
    overflow: hidden !important;
  }
  
  /* Default (large screens) */
  @media (min-width: 768px) {
    .chatbot-responsive-width {
      width: 480px;
    }
  }
  
  /* Specific breakpoints matching GrapesEditor */
  @media (max-width: 1554px) and (min-width: 1546px) {
    .chatbot-responsive-width {
      width: 480px;
    }
  }
  
  @media (max-width: 1545px) and (min-width: 1535px) {
    .chatbot-responsive-width {
      width: 480px;
    }
  }
  
  @media (max-width: 1534px) and (min-width: 1441px) {
    .chatbot-responsive-width {
      width: 480px;
    }
  }
  
  @media (max-width: 1440px) and (min-width: 1367px) {
    .chatbot-responsive-width {
      width: 480px;
    }
  }
  
  @media (max-width: 1368px) and (min-width: 1367px) {
    .chatbot-responsive-width {
      width: 480px;
    }
  }
  
  @media (max-width: 1366px) and (min-width: 1281px) {
    .chatbot-responsive-width {
      width: 480px;
    }
  }
  
  @media (max-width: 1280px) and (min-width: 1181px) {
    .chatbot-responsive-width {
      width: 480px;
    }
  }
  
  @media (max-width: 1180px) and (min-width: 1025px) {
    .chatbot-responsive-width {
      width: 480px;
    }
  }
  
  @media (max-width: 1024px) and (min-width: 913px) {
    .chatbot-responsive-width {
      width: 480px;
    }
  }
  
  @media (max-width: 912px) and (min-width: 821px) {
    .chatbot-responsive-width {
      width: 500px;
    }
  }
  
  @media (max-width: 820px) and (min-width: 769px) {
    .chatbot-responsive-width {
      width: 100%;
    }
  }
  
  @media (max-width: 768px) and (min-width: 441px) {
    .chatbot-responsive-width {
      width: 100%;
    }
  }
  
  @media (max-width: 440px) {
    .chatbot-responsive-width {
      width: 100%;
    }
  }

  /* Mobile keyboard adjustment */
  @media (max-width: 767px) {
    .chatbot-input-container {
      position: sticky;
      bottom: 0;
      z-index: 10;
      background-color: inherit;
    }
    
    /* Add padding to ensure input is visible above keyboard */
    @supports (-webkit-touch-callout: none) {
      .chatbot-input-container {
        padding-bottom: env(safe-area-inset-bottom, 16px);
      }
    }
  }
`

export const injectChatbotStyles = () => {
  // Check if the styles are already injected
  if (!document.getElementById('chatbot-responsive-styles')) {
    const styleTag = document.createElement('style');
    styleTag.id = 'chatbot-responsive-styles';
    styleTag.innerHTML = chatbotStyles;
    document.head.appendChild(styleTag);
  }
  
  // Add meta viewport tag to ensure proper rendering on mobile devices
  if (!document.querySelector('meta[name="viewport"][content*="viewport-fit=cover"]')) {
    const existingViewport = document.querySelector('meta[name="viewport"]');
    if (existingViewport) {
      const content = existingViewport.getAttribute('content') || '';
      if (!content.includes('viewport-fit=cover')) {
        existingViewport.setAttribute('content', `${content}, viewport-fit=cover`);
      }
    } else {
      const viewportMeta = document.createElement('meta');
      viewportMeta.name = 'viewport';
      viewportMeta.content = 'width=device-width, initial-scale=1, viewport-fit=cover';
      document.head.appendChild(viewportMeta);
    }
  }
  
  // Check for iPad Mini and apply special fix
  if (typeof window !== 'undefined') {
    const isIPadMini = detectIPadMini();
    if (isIPadMini) {
      document.documentElement.classList.add('ipad-mini');
      
      // Force layout recalculation for iPad Mini
      setTimeout(() => {
        const event = new Event('resize');
        window.dispatchEvent(event);
      }, 300);
    }
  }
};

// Helper function to detect iPad Mini
function detectIPadMini() {
  if (typeof window === 'undefined') return false;
  
  // iPad Mini 2021 viewport dimensions are around 744 x 1059
  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;
  
  // Check for iPad Mini in both orientations
  const isIPadMiniPortrait = 
    (viewportWidth >= 740 && viewportWidth <= 750) && 
    (viewportHeight >= 1050 && viewportHeight <= 1070);
    
  const isIPadMiniLandscape = 
    (viewportWidth >= 1050 && viewportWidth <= 1070) && 
    (viewportHeight >= 740 && viewportHeight <= 750);
  
  // Also check for iOS/iPadOS
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as unknown as { MSStream: unknown }).MSStream;
  
  return (isIPadMiniPortrait || isIPadMiniLandscape) && isIOS;
} 